// Use generated static icon components to avoid runtime factory issues.
import * as Generated from './icons.generated.jsx'

export const {
  BarChart2,
  Building2,
  ChevronRight,
  LifeBuoy,
  LockKeyhole,
  Package,
  Settings2,
  Shield,
  TrendingUp,
  Users,
  Wallet,
  ArrowRight,
  BarChart3,
  Boxes,
  LineChart,
  ArrowUpDown,
  LayoutGrid,
  Sparkles,
  CheckCircle2,
  ShieldCheck,
} = Generated

export default Generated
